export default {
  'toast.submitSuccess': 'Submitted successfully',
  'toast.submitFail': 'Submission Failed',
  'toast.emptyWarning': 'Please enter the content',
};
